<template>
   <div class="meet-detail">
    <div class="meet-detail-head">
      <div>{{meetingInfo.title}}</div>
      <div>{{meetingInfo.releaseDate}}</div>
    </div>
    <div class="meet-detail-main">
      <div v-html="meetingInfo.contents"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      meetingInfo:{},
      FILE_BASE_URL:this.$API.FILE_BASE_URL
    };
  },
  mounted() {
    this.meetingInfo = JSON.parse(localStorage.getItem("meetingInfo")) 
    this.queryPlacardById(this.meetingInfo.id)
  },
  methods: {
    queryPlacardById(id) {
      let params = {
        id: id,
      };
      this.$API.queryPlacardById(params);
    },
  }
};
</script>

<style lang="scss" scoped>
.meet-detail {
  width: 100%;
  margin-top: 40px;
}
.meet-detail-head {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > div:nth-child(1) {
    font-size: 20px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
    font-weight: 700;
    color: #333333;
  }
  > div:nth-child(2) {
    font-size: 13px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
    font-weight: 400;
    color: #777777;
    margin-top: 10px;
  }
}
.meet-detail-main{
   width: 1200px;
   margin: 0 auto;
}
</style>